/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AppointmentStatusEnum = {
    Booked: 'BOOKED',
    Cancelled: 'CANCELLED',
    CancelledLate: 'CANCELLED_LATE',
    CancelledPending: 'CANCELLED_PENDING',
    Attended: 'ATTENDED',
    Reserved: 'RESERVED'
} as const;
export type AppointmentStatusEnum = typeof AppointmentStatusEnum[keyof typeof AppointmentStatusEnum];

